<template>
  <div>
    <div v-if="!links.length" class="dw-empty">No shortcuts available.</div>
    <div v-else class="dw-link-grid">
      <component
        :is="linkTag(page)"
        v-for="page in links"
        :key="page.id"
        v-bind="linkProps(page)"
        class="dw-link-tile"
      >
        <span class="dw-link-tile-icon"><i :class="'fa ' + page.icon" aria-hidden="true"></i></span>
        <span class="dw-link-tile-label">{{ page.name }}</span>
      </component>
    </div>
  </div>
</template>

<script>
import { buildSiteMapSections, flattenSiteMapPages } from '../../utils/site_map_pages'

const MAX_LINKS = 8

export default {
  name: 'widget_quick_links',
  props: {
    user: { type: Object, required: true },
    viewAs: { type: String, default: null },
  },
  computed: {
    links() {
      const sections = buildSiteMapSections(this.user, this.viewAs)
      return flattenSiteMapPages(sections)
        .filter(page => page.accessible && page.route !== 'dashboard')
        .slice(0, MAX_LINKS)
    },
  },
  methods: {
    linkTag(page) {
      return page.external ? 'a' : 'router-link'
    },
    linkProps(page) {
      if (page.external) {
        return { href: page.path, target: '_blank', rel: 'noopener' }
      }
      if (page.path) {
        return { to: { path: page.path } }
      }
      return { to: { name: page.route, query: page.query } }
    },
  },
}
</script>
